import React from 'react';
import { ReactComponent as TrustpilotLogoSvg } from './trustpilot.svg';
import styles from './trustpilotLogo.less';
export var TrustpilotLogo = function () { return (React.createElement("a", { href: "https://uk.trustpilot.com/evaluate/beeyay.com", target: "_blank", rel: "noopener noreferrer" },
    React.createElement(TrustpilotLogoSvg, { className: styles.logo }))); };
